// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__-w1l-","content":"styles_content__2vV_m","checkbox":"styles_checkbox__27WNG","checkboxLabel":"styles_checkboxLabel__Qk0cO"};